<script setup lang="ts">
import {watchEffect, ref} from "vue";
import {Avatar, Button, ToggleSwitch} from "@/Components/Library";
import {Icon} from "@iconify/vue";
import User from "@/Models/User";
import useAuth from "@/Composables/auth";
import {useMainStore} from "@/Stores/store";
import {useStorage} from "@vueuse/core";
import UserMenu from "@/Layouts/UserMenu.vue";
import {RouterLink} from "vue-router";

const $store = useMainStore();
const {logOut} = useAuth();
const $user = new User();
const model = defineModel();
const emit = defineEmits<{
    showAskAlbieDrawer: [];
    toggleSidebar: [];
}>();
// const darkMode = useStorage(
//     "color-scheme",
//     window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light",
// );
const darkMode = ref(window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");

const userMenu = [
    // {
    //     label: "Admin",
    //     roles: ["admin", "super-admin"],
    //     icon: "prime:cog",
    //     to: "admin.dashboard",
    // },
    {
        label: "Feed",
        icon: {icon: "prime:list", width: 20},
        to: "feed",
    },
    {
        label: "Groups",
        icon: {icon: "prime:users", width: 20},
        to: "groups.index",
    },
    {
        label: "Questions",
        icon: {icon: "mage:message-question-mark-round", width: 18},
        to: "questions.index",
    },
    {
        label: "Responses",
        icon: {icon: "gg:check-r"},
        to: "responses.index",
    },
    {
        label: "Stimuli",
        icon: {icon: "prime:image", width: 20},
        to: "stimuli.index",
    },
    {
        label: "Contacts",
        icon: {icon: "prime:address-book", width: 20},
        to: "contacts.index",
    },
    // {
    //     label: "Profile",
    //     icon: "prime:user",
    //     to: "profile.edit",
    // },
    // {
    //     label: "Log out",
    //     icon: "prime:sign-out",
    //     command: () => {
    //         logOut();
    //     },
    // },
];

const openHelpDialog = () => {
    emit("showAskAlbieDrawer");
};
watchEffect(() => {
    if (darkMode.value === "dark") {
        document.documentElement.classList.add("dark");
    } else {
        document.documentElement.classList.remove("dark");
    }
});
</script>
<template>
    <div
        class="left-0 top-0 hidden h-screen w-64 flex-none flex-col border-r bg-white px-2 pb-4 transition-transform xl:fixed xl:flex dark:border-stone-900 dark:bg-stone-900"
        :class="{
            'fixed z-50': model,
            'absolute -translate-x-full': !model,
        }"
    >
        <slot name="logo">
            <div class="pointer-events-auto flex px-2 py-3">
                <a href="/">
                    <h1 class="text-3xl font-black tracking-[-0.175rem] text-askr-green">ASKr</h1>
                </a>
            </div>
        </slot>
        <div class="flex grow flex-col">
            <RouterLink :to="{name: 'profile.edit'}" class="mb-2 w-full">
                <div class="transition-color flex items-center gap-2 py-1 duration-200 lg:px-2">
                    <Avatar :user="$user" class="h-10 w-10 flex-none" shape="circle" />
                    <h6 class="">
                        {{ $user.user.first_name }}
                        <span class="font-bold">{{ $user.user.last_name }}</span>
                    </h6>
                </div>
            </RouterLink>
            <UserMenu @showAskAlbieDrawer="$emit('showAskAlbieDrawer')" />
        </div>
    </div>
</template>
<style></style>
